export const styles = {
  teacherAvailabilityCalenderButton: {
    display: 'flex',
    alignItems: 'center',
    marginTop: '5px',
    justifyContent: 'center',
  },
  calenderViewSelect: {
    'label + &': {
      marginTop: 3,
    },
    '& .MuiInputBase-input': {
      borderRadius: 24,
      position: 'relative',
      backgroundColor: '#fff',
      border: '2px solid #d3d3d3',
      fontSize: 20,
      fontWeight: 500,
      width: 120,
      padding: '10px 36px 10px 20px',
      textAlign: 'center',
      color: '#1d1d1f',
      '&:focus': {
        borderColor: '#bdbdbd',
      },
    },
  },
  teacherAvailabilityCalenderButtonImage: {
    width: '20px',
    height: '20px',
    marginInline: '20px',
    cursor: 'pointer',
  },
};
